import { connect } from "react-redux";
import CompleteDialog from "../components/CompleteDialog";
import { closeCompleteDialog } from "../redux/modules/completeDialog";

const mapStateToProps = state => ({ completeDialog: state.completeDialog });
const mapDispatchToProps = dispatch => ({
  handleClose: () => dispatch(closeCompleteDialog())
});

export default connect(mapStateToProps, mapDispatchToProps)(CompleteDialog);



// WEBPACK FOOTER //
// ./src/containers/CompleteDialogContainer.js